import { DELIVERY_METHOD_KIND } from "@dransay/api/models";
import { useCallback } from "react";
import { useVendorSelection } from "~/contexts/vendor-selection.context";
import { ExpressAvailabilityModal } from "~/features/products/express-availability-modal.component";
import { usePlpExpressAvailabilityModal } from "~/hooks/use-plp-express-availability-modal";

interface PlpExpressAvailabilityModalHostProps {
	enabled: boolean;
	postalCode: string | undefined;
	expressVendorIds: readonly string[];
}

/**
 * Must render under VendorSelectionProvider so the primary CTA updates both
 * the URL and the selection context (same path as the pharmacy picker).
 */
export function PlpExpressAvailabilityModalHost({
	enabled,
	postalCode,
	expressVendorIds,
}: Readonly<PlpExpressAvailabilityModalHostProps>) {
	const { setSelectedVendorAndDeliveryMethod } = useVendorSelection();

	// Browsing/URL state never uses "express-courier" -- it has no aggregation
	// group and is hidden from the header/filter selector (see
	// express-courier-delivery/behavior.md). Land on the pharmacy's shipping
	// catalog; express itself is offered later as a cart/checkout method.
	const navigateToPharmacy = useCallback(
		(vendorId: string) =>
			setSelectedVendorAndDeliveryMethod(
				vendorId,
				DELIVERY_METHOD_KIND.SHIPPING,
			),
		[setSelectedVendorAndDeliveryMethod],
	);

	const { isModalOpen, setModalOpen, showCourierPharmacies } =
		usePlpExpressAvailabilityModal({
			enabled,
			postalCode,
			expressVendorIds,
			onNavigateToPharmacy: navigateToPharmacy,
		});

	return (
		<ExpressAvailabilityModal
			open={isModalOpen}
			onOpenChange={setModalOpen}
			onShowCourierPharmacies={showCourierPharmacies}
		/>
	);
}
